import React, { useState } from 'react';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../utils/Button';
import FocusControl from '../../../utils/FocusControl';
import InputField, { TextareaField } from '../../../utils/InputField';
import { ApiUpdateSupportTicket } from '../SupportTicketOperation';

function UpdateIssueTicketModal({ closeModal, handleReload, issueData }) {
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const [formData, setFormData] = useState({
        supportTicketId: issueData?.id,
        Message: issueData?.lastMessage,
        AttachmentUrl: ''
    });

    const { setMessage } = useTemplate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'IsUrgent') {
            setFormData((d) => ({ ...d, [name]: !formData.IsUrgent }));
            return;
        }
        setFormData((d) => ({ ...d, [name]: value }));
    };

    const handleSave = (e) => {
        setLoading(true);
        e.preventDefault();

        ApiUpdateSupportTicket(issueData?.id, formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                handleReload();
                closeModal();
                setMessage({ type: 'success', text: title });
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString() });
            });
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleSave} encType="multipart/form-data" className="flex flex-col gap-4">
            <InputField
                label="Attachment Url"
                name="AttachmentUrl"
                placeholder="Type attachment url..."
                formData={formData}
                onChange={handleChange}
                height="h-[64px]"
            />

            <TextareaField
                label="Type Issue"
                name="Message"
                placeholder="Type Issue"
                formData={formData}
                onChange={handleChange}
                height="h-28"
            />

            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Update" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default UpdateIssueTicketModal;
